import { Alert, Box, Button, Stack, TextField } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import * as React from 'react';
import useModalContext from 'v2/components/Modal/useModalContext';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useWizardStepContext from 'v2/components/WizardModal/useWizardStepContext';

const STEP_INDEX = 2;

interface Props {
  apiKey: string | null;
}

const FinishStep: React.FC<Props> = ({ apiKey }) => {
  const { translation } = useTranslation();
  const { closeModal } = useModalContext();
  const { showSnackbar } = useSnackbarContext();
  const { setFooterContent, steps } = useWizardStepContext();

  const handleCopy = () => {
    if (apiKey) {
      navigator.clipboard.writeText(apiKey).then(
        () => showSnackbar(translation.copied_key_to_clipboard, { severity: 'success' }),
        () => showSnackbar(translation.failed_to_copy_key_to_clipboard, { severity: 'error' })
      );
    }
  };

  React.useLayoutEffect(() => {
    setFooterContent(
      STEP_INDEX,
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', md: 'row' }, gap: 2 }}>
        <Button key="finish-step-close" id="finish-button" variant="contained" onClick={closeModal}>
          {translation.finish}
        </Button>
      </Box>
    );
  }, [closeModal, setFooterContent, steps, translation]);

  return (
    <Stack spacing={2}>
      <TextField
        id="input-api-key"
        value={apiKey ?? ''}
        label={translation.api_key}
        slotProps={{ input: { readOnly: true } }}
        fullWidth
      />
      <Button id="copy-key-button" variant="outlined" fullWidth onClick={handleCopy}>
        {translation.copy_key_to_clipboard}
      </Button>
      <Alert severity="info">
        {
          translation.this_is_your_unique_key_and_it_is_non_recoverable_if_you_lose_this_api_key_you_will_have_to_create_a_new_one
        }
      </Alert>
    </Stack>
  );
};

export default FinishStep;
